<template>
  <b-row class="contact-details">
    <b-col cols="12" sm="10">
      <ContactDetailLine :lineBreak="lineBreak" label="Name:" :value="`${contact.firstName} ${contact.lastName}`"/>
      <ContactDetailLine v-if="contact.companyName" :lineBreak="lineBreak" label="Company Name:" :value="contact.companyName"/>
      <ContactDetailLine v-if="contact.forestId" :lineBreak="lineBreak" label="FOResT ID:" :value="contact.forestId"/>
      <slot></slot>
      <AddressDetails
        :lineBreak="lineBreak"
        class="mb-2"
        title="Physical Address"
        :address="contact.physicalAddress"
      />
      <AddressDetails
        :lineBreak="lineBreak"
        class="mb-2"
        title="Mailing Address"
        :address="contact.mailingAddress"
      />
      <ContactDetailLine v-if="showAll || (mfsUser && isSummaryPage)"
        :lineBreak="lineBreak"
        label="Phone:"
        :url="`tel:${contact.phoneNumber}`"
        :value="contact.phoneNumber | phoneString"
      />
      <ContactDetailLine v-if="showAll || (mfsUser && isSummaryPage)"
        :lineBreak="lineBreak"
        label="Email:"
        :url="`mailto:${contact.email}`"
        :value="contact.email"
      />
    </b-col>
    <b-col
      cols="12"
      sm="2"
      v-if="!disableRemove"
      class="text-right my-3 my-sm-0">
      <b-button
        pill
        class="w-100 w-sm-auto"
        variant="danger"
        @click="remove"
        :disabled="mfsAdmin"
        aria-label="Remove contact"
        >Remove</b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressDetails from '@/components/account/AddressDetails.vue';
import ContactDetailLine from '@/components/common/ContactDetailLine.vue';

export default {
  name: 'ContactDetails',
  components: {
    AddressDetails,
    ContactDetailLine,
  },
  props: {
    contact: {
      type: Object,
      default() {
        return {
          physicalAddress: {},
          mailingAddress: {},
        };
      },
    },
    disableRemove: {
      type: Boolean,
      default: false,
    },
    lineBreak: {
      type: Boolean,
      default: false,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    isSummaryPage: {
      type: Boolean,
      default: false,
    },
    removeActionName: {
      type: String,
      default: null,
    },
  },
  methods: {
    remove() {
      if (this.mfsAdmin) {
        return;
      }
      this.$store.dispatch(this.removeActionName);
    },
  },
  computed: {
    ...mapGetters('User', ['mfsUser', 'mfsAdmin']),
  },
};
</script>
